import React from 'react';
import ManageProjectTable from '../components/dashboard/ManageProjectTable';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import ModalMenu from '../components/Modal/ModalMenu';
import ModalSearch from '../components/Modal/ModalSearch';
import Scrollup from '../components/Scrollup/Scrollup';

const ManageProject = () => {
    return (

        <div className="main">
            <Header />
           <ManageProjectTable/>
            <Footer/>
            <ModalSearch />
            <ModalMenu />
            <Scrollup />
        </div>

        
    );
};

export default ManageProject;